import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '@app/store/reducer'

const mchatStateSelector = (state: AppState) => state.mchat

export const stepSelector = createSelector(mchatStateSelector, ({ flowData: { currentStep } }) => currentStep)
export const currentQuestionSelector = createSelector(
  mchatStateSelector,
  ({ questions: { currentQuestion } }) => currentQuestion
)
export const scoreSelector = createSelector(mchatStateSelector, ({ questions: { score } }) => score)
export const answersSelector = createSelector(mchatStateSelector, ({ questions: { answers } }) => answers)
export const inputSelector = createSelector(mchatStateSelector, ({ inputData }) => inputData)
